module.exports = __webpack_public_path__ + "img/webcam_icon.f9a5ec7b.svg";